var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task"},[_c('h2',[_vm._v(_vm._s(_vm.task.text))]),_c('div',[_vm._v("Added on "+_vm._s(_vm.task.date))]),_c('i',{staticClass:"fas fa-times",on:{"click":function($event){return _vm.$emit('delete-task', _vm.task.id)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }